import { render, staticRenderFns } from "./page8.vue?vue&type=template&id=49c8ce1c&scoped=true&"
import script from "./page8.vue?vue&type=script&lang=js&"
export * from "./page8.vue?vue&type=script&lang=js&"
import style0 from "./page8.vue?vue&type=style&index=0&id=49c8ce1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8ce1c",
  null
  
)

export default component.exports